<!--联系人下拉选择器-->
<template>
    <el-autocomplete
        size="small"
        v-model="ContactIds"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入关键词"
        @select="handleChange"
        @blur="handleBlur">
        <template slot-scope="{ item }">
            <div class="label" :title="item.value" >{{ item.value }}</div>
        </template>
    </el-autocomplete>
</template>

<script>
import CommonService from "~/services/common";
export default {
    name: "ContactSelect",
    props: {
        isMultiple: true,
        customerId: "",
    },
    data() {
        return {
            //定义变量
            ContactIds: null
        };
    },

    methods: {

        querySearchAsync(queryString, cb) {
            let qs = (queryString || '').toString().trim() || undefined;
            let params = {
                fields: 'id,name',
                name: qs
            };
            CommonService.getContacts(params).then(res => {
                if (!res.data) return;
                let results = res.data.filter(item => {
                    if (!qs) return true;
                        return item.name.toString().indexOf(qs)> -1;
                }).map( item => {
                    return { 
                        value: item.name, 
                        label: item.id 
                    };
                });
                cb(results)
            });
        },

        //select value值变化时触发
        handleChange(object) {
            this.$emit("change", object);
        },  

        handleBlur($event) {
            this.$emit("change", $event.target);
        },
        
        reset() {
            this.ContactIds = '';
        }      
    }
}


</script>


// WEBPACK FOOTER //
// src/widgets/ContactSelect.vue